import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, inject, Injectable, Directive, Input, HostListener, Inject } from '@angular/core';
import { ClassSwitch } from '@js-dot/ui';
import { DotInheritBase } from '@ng-dot/ux/inherit';
import * as i1 from '@ng-dot/core';
import { DotComponentService } from '@ng-dot/core';
import { DOCUMENT } from '@angular/common';
class DotUpStyleComponent {
  static ɵfac = function DotUpStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotUpStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotUpStyleComponent,
    selectors: [["dot-up-style"]],
    decls: 0,
    vars: 0,
    template: function DotUpStyleComponent_Template(rf, ctx) {},
    styles: [":root{--up-color:black;--up-to:1;--up-left:0;--up-top:-1;--up-bottom-x-from:2px;--up-bottom-y-from:2px;--up-bottom-blur-from:1px;--up-bottom-spread-from:-1px;--up-bottom-alpha-from:20%;--up-bottom-x-to:7px;--up-bottom-y-to:7px;--up-bottom-blur-to:8px;--up-bottom-spread-to:-4px;--up-bottom-alpha-to:20%;--up-in-x-from:1px;--up-in-y-from:1px;--up-in-blur-from:1px;--up-in-spread-from:0px;--up-in-alpha-from:14%;--up-in-x-to:12px;--up-in-y-to:12px;--up-in-blur-to:17px;--up-in-spread-to:2px;--up-in-alpha-to:14%;--up-out-x-from:1px;--up-out-y-from:1px;--up-out-blur-from:3px;--up-out-spread-from:0px;--up-out-alpha-from:12%;--up-out-x-to:5px;--up-out-y-to:5px;--up-out-blur-to:22px;--up-out-spread-to:4px;--up-out-alpha-to:12%;--upEnd:12;--upBottomXStep:calc((var(--up-bottom-x-to ) - var(--up-bottom-x-from )) / var(--upEnd));--upBottomYStep:calc((var(--up-bottom-y-to ) - var(--up-bottom-y-from )) / var(--upEnd));--upBottomBlurStep:calc((var(--up-bottom-blur-to ) - var(--up-bottom-blur-from )) / var(--upEnd));--upBottomSpreadStep:calc((var(--up-bottom-spread-to) - var(--up-bottom-spread-from)) / var(--upEnd));--upBottomAlphaStep:calc((var(--up-bottom-alpha-to ) - var(--up-bottom-alpha-from )) / var(--upEnd));--upInXStep:calc((var(--up-in-x-to ) - var(--up-in-x-from )) / var(--upEnd));--upInYStep:calc((var(--up-in-y-to ) - var(--up-in-y-from )) / var(--upEnd));--upInBlurStep:calc((var(--up-in-blur-to ) - var(--up-in-blur-from )) / var(--upEnd));--upInSpreadStep:calc((var(--up-in-spread-to ) - var(--up-in-spread-from )) / var(--upEnd));--upInAlphaStep:calc((var(--up-in-alpha-to ) - var(--up-in-alpha-from )) / var(--upEnd));--upOutXStep:calc((var(--up-out-x-to ) - var(--up-out-x-from )) / var(--upEnd));--upOutYStep:calc((var(--up-out-y-to ) - var(--up-out-y-from )) / var(--upEnd));--upOutBlurStep:calc((var(--up-out-blur-to ) - var(--up-out-blur-from )) / var(--upEnd));--upOutSpreadStep:calc((var(--up-out-spread-to ) - var(--up-out-spread-from )) / var(--upEnd));--upOutAlphaStep:calc((var(--up-out-alpha-to ) - var(--up-out-alpha-from )) / var(--upEnd))}.dot-up1,.dot-up10,.dot-up11,.dot-up12,.dot-up2,.dot-up3,.dot-up4,.dot-up5,.dot-up6,.dot-up7,.dot-up8,.dot-up9{--upTo:calc(var(--up-to) - 1);--upBottomXAmount:calc(var(--upBottomXStep) * var(--upTo) + var(--up-bottom-x-from));--upBottomYAmount:calc(var(--upBottomYStep) * var(--upTo) + var(--up-bottom-y-from));--upInXAmount:calc(var(--upInXStep ) * var(--upTo) + var(--up-in-x-from));--upInYAmount:calc(var(--upInYStep ) * var(--upTo) + var(--up-in-y-from));--upOutXAmount:calc(var(--upOutXStep ) * var(--upTo) + var(--up-out-x-from));--upOutYAmount:calc(var(--upOutYStep ) * var(--upTo) + var(--up-out-y-from));--upBottomX:calc(((var(--upBottomXAmount ) * -1) - var(--upBottomXAmount)) * var(--up-left));--upInX:calc(((var(--upInXAmount ) * -1) - var(--upInXAmount )) * var(--up-left));--upOutX:calc(((var(--upOutXAmount ) * -1) - var(--upOutXAmount )) * var(--up-left));--upBottomY:calc(((var(--upBottomYAmount ) * -1) - var(--upBottomYAmount)) * var(--up-top));--upInY:calc(((var(--upInYAmount ) * -1) - var(--upInYAmount )) * var(--up-top));--upOutY:calc(((var(--upOutYAmount ) * -1) - var(--upOutYAmount )) * var(--up-top));--upBottomBlur:calc(var(--upBottomBlurStep ) * var(--upTo) + var(--up-bottom-blur-from));--upInBlur:calc(var(--upInBlurStep ) * var(--upTo) + var(--up-in-blur-from));--upOutBlur:calc(var(--upOutBlurStep ) * var(--upTo) + var(--up-out-blur-from));--upBottomSpread:calc(var(--upBottomSpreadStep) * var(--upTo) + var(--up-bottom-spread-from));--upInSpread:calc(var(--upInSpreadStep ) * var(--upTo) + var(--up-in-spread-from));--upOutSpread:calc(var(--upOutSpreadStep ) * var(--upTo) + var(--up-out-spread-from));--upBottomAlpha:calc(var(--upBottomAlphaStep ) * var(--upTo) + var(--up-bottom-alpha-from));--upInAlpha:calc(var(--upInAlphaStep ) * var(--upTo) + var(--up-in-alpha-from));--upOutAlpha:calc(var(--upOutAlphaStep ) * var(--upTo) + var(--up-out-alpha-from));--upBottomColor:color-mix(in srgb, transparent, var(--up-color) var(--upBottomAlpha));--upInColor:color-mix(in srgb, transparent, var(--up-color) var(--upInAlpha));--upOutColor:color-mix(in srgb, transparent, var(--up-color) var(--upOutAlpha));box-shadow:var(--upBottomX) var(--upBottomY) var(--upBottomBlur) var(--upBottomSpread) var(--upBottomColor),var(--upInX) var(--upInY) var(--upInBlur) var(--upInSpread) var(--upInColor),var(--upOutX) var(--upOutY) var(--upOutBlur) var(--upOutSpread) var(--upOutColor);transition:box-shadow .12s}.dot-up1{--up-to:1}.dot-up2{--up-to:2}.dot-up3{--up-to:3}.dot-up4{--up-to:4}.dot-up5{--up-to:5}.dot-up6{--up-to:6}.dot-up7{--up-to:7}.dot-up8{--up-to:8}.dot-up9{--up-to:9}.dot-up10{--up-to:10}.dot-up11{--up-to:11}.dot-up12{--up-to:12}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotUpStyleComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-up-style',
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: [":root{--up-color:black;--up-to:1;--up-left:0;--up-top:-1;--up-bottom-x-from:2px;--up-bottom-y-from:2px;--up-bottom-blur-from:1px;--up-bottom-spread-from:-1px;--up-bottom-alpha-from:20%;--up-bottom-x-to:7px;--up-bottom-y-to:7px;--up-bottom-blur-to:8px;--up-bottom-spread-to:-4px;--up-bottom-alpha-to:20%;--up-in-x-from:1px;--up-in-y-from:1px;--up-in-blur-from:1px;--up-in-spread-from:0px;--up-in-alpha-from:14%;--up-in-x-to:12px;--up-in-y-to:12px;--up-in-blur-to:17px;--up-in-spread-to:2px;--up-in-alpha-to:14%;--up-out-x-from:1px;--up-out-y-from:1px;--up-out-blur-from:3px;--up-out-spread-from:0px;--up-out-alpha-from:12%;--up-out-x-to:5px;--up-out-y-to:5px;--up-out-blur-to:22px;--up-out-spread-to:4px;--up-out-alpha-to:12%;--upEnd:12;--upBottomXStep:calc((var(--up-bottom-x-to ) - var(--up-bottom-x-from )) / var(--upEnd));--upBottomYStep:calc((var(--up-bottom-y-to ) - var(--up-bottom-y-from )) / var(--upEnd));--upBottomBlurStep:calc((var(--up-bottom-blur-to ) - var(--up-bottom-blur-from )) / var(--upEnd));--upBottomSpreadStep:calc((var(--up-bottom-spread-to) - var(--up-bottom-spread-from)) / var(--upEnd));--upBottomAlphaStep:calc((var(--up-bottom-alpha-to ) - var(--up-bottom-alpha-from )) / var(--upEnd));--upInXStep:calc((var(--up-in-x-to ) - var(--up-in-x-from )) / var(--upEnd));--upInYStep:calc((var(--up-in-y-to ) - var(--up-in-y-from )) / var(--upEnd));--upInBlurStep:calc((var(--up-in-blur-to ) - var(--up-in-blur-from )) / var(--upEnd));--upInSpreadStep:calc((var(--up-in-spread-to ) - var(--up-in-spread-from )) / var(--upEnd));--upInAlphaStep:calc((var(--up-in-alpha-to ) - var(--up-in-alpha-from )) / var(--upEnd));--upOutXStep:calc((var(--up-out-x-to ) - var(--up-out-x-from )) / var(--upEnd));--upOutYStep:calc((var(--up-out-y-to ) - var(--up-out-y-from )) / var(--upEnd));--upOutBlurStep:calc((var(--up-out-blur-to ) - var(--up-out-blur-from )) / var(--upEnd));--upOutSpreadStep:calc((var(--up-out-spread-to ) - var(--up-out-spread-from )) / var(--upEnd));--upOutAlphaStep:calc((var(--up-out-alpha-to ) - var(--up-out-alpha-from )) / var(--upEnd))}.dot-up1,.dot-up10,.dot-up11,.dot-up12,.dot-up2,.dot-up3,.dot-up4,.dot-up5,.dot-up6,.dot-up7,.dot-up8,.dot-up9{--upTo:calc(var(--up-to) - 1);--upBottomXAmount:calc(var(--upBottomXStep) * var(--upTo) + var(--up-bottom-x-from));--upBottomYAmount:calc(var(--upBottomYStep) * var(--upTo) + var(--up-bottom-y-from));--upInXAmount:calc(var(--upInXStep ) * var(--upTo) + var(--up-in-x-from));--upInYAmount:calc(var(--upInYStep ) * var(--upTo) + var(--up-in-y-from));--upOutXAmount:calc(var(--upOutXStep ) * var(--upTo) + var(--up-out-x-from));--upOutYAmount:calc(var(--upOutYStep ) * var(--upTo) + var(--up-out-y-from));--upBottomX:calc(((var(--upBottomXAmount ) * -1) - var(--upBottomXAmount)) * var(--up-left));--upInX:calc(((var(--upInXAmount ) * -1) - var(--upInXAmount )) * var(--up-left));--upOutX:calc(((var(--upOutXAmount ) * -1) - var(--upOutXAmount )) * var(--up-left));--upBottomY:calc(((var(--upBottomYAmount ) * -1) - var(--upBottomYAmount)) * var(--up-top));--upInY:calc(((var(--upInYAmount ) * -1) - var(--upInYAmount )) * var(--up-top));--upOutY:calc(((var(--upOutYAmount ) * -1) - var(--upOutYAmount )) * var(--up-top));--upBottomBlur:calc(var(--upBottomBlurStep ) * var(--upTo) + var(--up-bottom-blur-from));--upInBlur:calc(var(--upInBlurStep ) * var(--upTo) + var(--up-in-blur-from));--upOutBlur:calc(var(--upOutBlurStep ) * var(--upTo) + var(--up-out-blur-from));--upBottomSpread:calc(var(--upBottomSpreadStep) * var(--upTo) + var(--up-bottom-spread-from));--upInSpread:calc(var(--upInSpreadStep ) * var(--upTo) + var(--up-in-spread-from));--upOutSpread:calc(var(--upOutSpreadStep ) * var(--upTo) + var(--up-out-spread-from));--upBottomAlpha:calc(var(--upBottomAlphaStep ) * var(--upTo) + var(--up-bottom-alpha-from));--upInAlpha:calc(var(--upInAlphaStep ) * var(--upTo) + var(--up-in-alpha-from));--upOutAlpha:calc(var(--upOutAlphaStep ) * var(--upTo) + var(--up-out-alpha-from));--upBottomColor:color-mix(in srgb, transparent, var(--up-color) var(--upBottomAlpha));--upInColor:color-mix(in srgb, transparent, var(--up-color) var(--upInAlpha));--upOutColor:color-mix(in srgb, transparent, var(--up-color) var(--upOutAlpha));box-shadow:var(--upBottomX) var(--upBottomY) var(--upBottomBlur) var(--upBottomSpread) var(--upBottomColor),var(--upInX) var(--upInY) var(--upInBlur) var(--upInSpread) var(--upInColor),var(--upOutX) var(--upOutY) var(--upOutBlur) var(--upOutSpread) var(--upOutColor);transition:box-shadow .12s}.dot-up1{--up-to:1}.dot-up2{--up-to:2}.dot-up3{--up-to:3}.dot-up4{--up-to:4}.dot-up5{--up-to:5}.dot-up6{--up-to:6}.dot-up7{--up-to:7}.dot-up8{--up-to:8}.dot-up9{--up-to:9}.dot-up10{--up-to:10}.dot-up11{--up-to:11}.dot-up12{--up-to:12}\n"]
    }]
  }], null, null);
})();
class DotUpStyleService {
  constructor() {
    inject(DotComponentService).append(DotUpStyleComponent);
  }
  static ɵfac = function DotUpStyleService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotUpStyleService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotUpStyleService,
    factory: DotUpStyleService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotUpStyleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class DotUpDirective extends DotInheritBase {
  _style;
  fromSelector;
  up;
  upTo;
  upColor;
  _class;
  constructor(_style, elementRef) {
    super();
    this._style = _style;
    const host = elementRef.nativeElement;
    this._class = new ClassSwitch(host);
  }
  ngOnInit() {
    if (this.up || this.upTo) {
      this._renderUp();
    }
  }
  ngOnChanges(changes) {
    for (let property in changes) {
      if (changes.hasOwnProperty(property)) {
        this[property] = changes[property].currentValue;
      }
    }
    if ('fromSelector' in changes || 'up' in changes || 'upTo' in changes || 'upColor' in changes) {
      if ('fromSelector' in changes) {
        this.up = this.fromSelector;
      }
      if ('up' in changes) {
        this._upUpdateAmount();
      }
      this._upUpdateClass();
    }
  }
  dotOnInherit() {
    this._renderUp();
  }
  _upUpdateAmount() {
    const {
      up
    } = this;
    if (typeof up === 'string' && up.includes('-')) {
      const [normal, hover] = up.split('-');
      this.up = +normal;
      this.upTo = +hover;
    }
  }
  _upUpdateClass() {
    const {
      _class
    } = this;
    const up = this.inherit('up');
    if (up) {
      _class.set('dot-up' + up);
    } else {
      _class.pop();
    }
  }
  _renderUp() {
    this._upUpdateAmount();
    this._upUpdateClass();
  }
  _upOnMouseEnter() {
    const {
      upTo
    } = this;
    if (upTo) {
      this._class.set('dot-up' + upTo);
    }
  }
  _upOnMouseLeave() {
    if (this.upTo) {
      this._upUpdateClass();
    }
  }
  static ɵfac = function DotUpDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotUpDirective)(i0.ɵɵdirectiveInject(DotUpStyleService), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotUpDirective,
    selectors: [["", "dotUp", ""]],
    hostBindings: function DotUpDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mouseenter", function DotUpDirective_mouseenter_HostBindingHandler() {
          return ctx._upOnMouseEnter();
        })("mouseleave", function DotUpDirective_mouseleave_HostBindingHandler() {
          return ctx._upOnMouseLeave();
        });
      }
    },
    inputs: {
      fromSelector: [0, "dotUp", "fromSelector"],
      up: "up",
      upTo: "upTo",
      upColor: "upColor"
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotUpDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotUp]'
    }]
  }], () => [{
    type: DotUpStyleService
  }, {
    type: i0.ElementRef
  }], {
    fromSelector: [{
      type: Input,
      args: [{
        alias: 'dotUp'
      }]
    }],
    up: [{
      type: Input
    }],
    upTo: [{
      type: Input
    }],
    upColor: [{
      type: Input
    }],
    _upOnMouseEnter: [{
      type: HostListener,
      args: ['mouseenter']
    }],
    _upOnMouseLeave: [{
      type: HostListener,
      args: ['mouseleave']
    }]
  });
})();
class DotUpLiveEffectService {
  constructor(_renderer, document) {
    const {
      body
    } = document;
    _renderer._renderer.listen(document, 'mousemove', event => {
      _renderer.setStyle(body, '--up-left', (event.x / body.clientWidth * 2 - 1).toFixed(1));
      _renderer.setStyle(body, '--up-top', (event.y / body.clientHeight * 2 - 1).toFixed(1));
    });
  }
  static ɵfac = function DotUpLiveEffectService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotUpLiveEffectService)(i0.ɵɵinject(i1.DotRendererService), i0.ɵɵinject(DOCUMENT));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotUpLiveEffectService,
    factory: DotUpLiveEffectService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotUpLiveEffectService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.DotRendererService
  }, {
    type: HTMLDocument,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], null);
})();
class DotUpXLiveEffectService {
  _renderer;
  constructor(_renderer, document) {
    this._renderer = _renderer;
    const {
      body
    } = document;
    _renderer._renderer.listen(document, 'mousemove', event => {
      _renderer.setStyle(body, '--up-left', (event.x / body.clientWidth * 2 - 1).toFixed(1));
    });
  }
  static ɵfac = function DotUpXLiveEffectService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotUpXLiveEffectService)(i0.ɵɵinject(i1.DotRendererService), i0.ɵɵinject(DOCUMENT));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotUpXLiveEffectService,
    factory: DotUpXLiveEffectService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotUpXLiveEffectService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.DotRendererService
  }, {
    type: HTMLDocument,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], null);
})();
class DotUpYLiveEffectService {
  constructor(_renderer, document) {
    const {
      body
    } = document;
    _renderer._renderer.listen(document, 'mousemove', event => {
      _renderer.setStyle(body, '--up-top', (event.y / body.clientHeight * 2 - 1).toFixed(1));
    });
  }
  static ɵfac = function DotUpYLiveEffectService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotUpYLiveEffectService)(i0.ɵɵinject(i1.DotRendererService), i0.ɵɵinject(DOCUMENT));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotUpYLiveEffectService,
    factory: DotUpYLiveEffectService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotUpYLiveEffectService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.DotRendererService
  }, {
    type: HTMLDocument,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotUpDirective, DotUpLiveEffectService, DotUpXLiveEffectService, DotUpYLiveEffectService };
